module.exports = __webpack_public_path__ + "img/page_right_bottom.d16692bc.png";